module.exports = __webpack_public_path__ + "static/media/favicon.cbcc4dce.png";